/**
 * Prefetch de chunks lazy de rotas no hover/focus/touch.
 * Os caminhos dinâmicos DEVEM bater com os usados em src/App.tsx
 * para que o Vite emita um único chunk reaproveitado na navegação real.
 */

type RouteKey = "marcaDetalhe" | "marcas" | "causaDetalhe" | "causas";

const importers: Record<RouteKey, () => Promise<unknown>> = {
  marcaDetalhe: () => import("@/pages/MarcaDetalhe"),
  marcas: () => import("@/pages/Marcas"),
  causaDetalhe: () => import("@/pages/CausaDetalhe"),
  causas: () => import("@/pages/Causas"),
};

const fired = new Set<RouteKey>();

function runIdle(fn: () => void) {
  if (typeof window === "undefined") return;
  const ric = (window as any).requestIdleCallback as
    | ((cb: () => void, opts?: { timeout?: number }) => number)
    | undefined;
  if (ric) ric(fn, { timeout: 1500 });
  else setTimeout(fn, 0);
}

export function prefetchRoute(key: RouteKey | null | undefined) {
  if (!key || fired.has(key)) return;
  fired.add(key);
  runIdle(() => {
    importers[key]().catch(() => fired.delete(key));
  });
}

export function prefetchByPath(to: unknown): RouteKey | null {
  const path = typeof to === "string" ? to : (to as any)?.pathname;
  if (typeof path !== "string") return null;
  if (path.startsWith("/marca/")) return "marcaDetalhe";
  if (path === "/marcas") return "marcas";
  if (path.startsWith("/causa/")) return "causaDetalhe";
  if (path === "/causas") return "causas";
  return null;
}